<div id="content">
  <p class="mat-h1 titulo">Alterações não salvas</p>
  <p class="mat-body mensagem">Você tem alterações não salvas nesta tela. O que deseja fazer?</p>

  <div class="container-botoes inline-element">
    <button mat-button class="button btn-voltar" (click)="cancelar()">Cancelar</button>
    <button mat-button class="button btn-sair" (click)="sairSemSalvar()">Sair sem salvar</button>
    <button mat-stroked-button class="button btn-acao" (click)="salvar()">Salvar</button>
  </div>
</div>
